"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _r10SourceLibrary = require("r10-source-library");
var _constants = require("../../constants");
var _useTranslation = _interopRequireDefault(require("../../hooks/useTranslation"));
var _WrapByDataAttributes = _interopRequireDefault(require("../../utils/WrapByDataAttributes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var BasicPlanDetails = function BasicPlanDetails() {
  var isSmall = window.matchMedia("(max-width:".concat(_r10SourceLibrary.themeWS10.breakpoints.md, "px)")).matches;
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return state[_constants.PKG_NAME];
    }),
    rates = _useSelector.rates;
  var t = (0, _useTranslation.default)();
  return /*#__PURE__*/_react.default.createElement(_WrapByDataAttributes.default, {
    "data-testid": "plan-rates"
  }, rates.map(function (rate) {
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: rate.type
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
      justify: "between",
      align: "center"
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Container, {
      paddingLevel: 0
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      size: 1,
      noMargin: true
    }, t(_constants.TRANSLATION_MAPPING[rate.type])), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
      size: 1,
      noMargin: true
    }, rate.usage)), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      spacingLevel: {
        top: 4,
        right: 4
      }
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      spacingLevel: {
        right: 1
      }
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
      size: 1,
      noMargin: true
    }, rate.amount, rate.currency)), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Tooltip, {
      text: t('flatRate', {
        rateValue: rate.value,
        rateUnit: rate.unitOfMeasure
      })
    })))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
      marginBottom: isSmall ? 0 : 2,
      marginTop: isSmall ? 0 : 2
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, {
      appearance: "secondary"
    })));
  }));
};
var _default = BasicPlanDetails;
exports.default = _default;